import { lightColorPalette } from '@linearb/linui-common';
import { Body2 } from '@linearb/linui-common/typography';
import { getColor } from 'common/constants/_colors';
import { verticalScroller } from 'components/base/scroller';
import styled from 'styled-components';

export const StyledCreateEditProjectModal = styled.div`
  display: flex;
  flex-direction: column;
  padding: 2rem;
  height: 100%;
  justify-content: space-between;
  box-sizing: border-box;

  footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    direction: row;
    border-top: 1px solid ${getColor('alto')};
    padding-top: 2rem;
  }
`;

export const StyledSectionTitle = styled(Body2)`
  text-transform: uppercase;
  color: ${lightColorPalette.lbTextSubdued};
  &.mandatory::before {
    content: '*';
    color: red;
    margin-right: 2px;
  }
`;

export const StyledScroll = styled.div`
  max-height: 47rem;
  ${verticalScroller()};
`;
